import React, {useEffect, useState} from 'react';
import {ReasonCaptureModal} from './ReasonCaptureModal';
import {registerReasonPrompt} from '../../Utils/reasonPrompt';

// Mounted once at the app root. Registers a handler that any request can call
// (via promptReason) to capture an audit reason on demand, then resolves the
// caller's promise with the reason (or null on cancel).
export const ReasonPromptHost = () => {
    const [pending, setPending] = useState(null); // { resolve, context }

    useEffect(() => {
        registerReasonPrompt((context) =>
            new Promise((resolve) => setPending({resolve, context}))
        );
    }, []);

    if (!pending) return null;

    const finish = (value) => {
        pending.resolve(value);
        setPending(null);
    };

    return (
        <ReasonCaptureModal
            title={pending.context?.title || 'Reason required'}
            onCancel={() => finish(null)}
            onConfirm={(reason) => finish(reason)}
        />
    );
};

export default ReasonPromptHost;
